module.exports = __webpack_public_path__ + "static/media/Heraldo-de-Aragon.35d58084.png";